// A cluster's custom login field holds a Social Security number when its label
// says so ("SSN", "Last 4 of SSN", "Social Security #"), the same rule the
// portal API uses to match it on its digits.
export type SsnFormat = "ssn" | "ssn-last4";

export const ssnFormatForLabel = (label?: string): SsnFormat | undefined => {
  const text = label ?? "";
  if (!/\bssn\b|social\s*security/i.test(text)) {
    return undefined;
  }
  return /\blast\s*(4|four)\b/i.test(text) ? "ssn-last4" : "ssn";
};

const maxDigits = (format: SsnFormat) => (format === "ssn-last4" ? 4 : 9);

// Shape the number as it is typed: "123456789" becomes "123-45-6789". A dash
// is only added once the next digit arrives, so Backspace is never stuck on
// one. A last-4 field keeps just the four digits.
export const formatSsnInput = (value: string, format: SsnFormat): string => {
  const digits = value.replace(/\D/g, "").slice(0, maxDigits(format));
  if (format === "ssn-last4") {
    return digits;
  }
  return [digits.slice(0, 3), digits.slice(3, 5), digits.slice(5)]
    .filter(Boolean)
    .join("-");
};

export const isSsnComplete = (value: string, format: SsnFormat): boolean =>
  value.replace(/\D/g, "").length === maxDigits(format);
